import useStyles from './styles';
import MuiButton from '@material-ui/core/Button';
import LoadingAnimation from '@src/shared/animations/LoadingAnimation';
import React from 'react';
import JetFontIcon, { JET_FONTICON_ALIASES } from '../JetFontIcon';
import { JetSpinner } from '../JetSpinner';
const JetButton = (props : any) => {
    const classes = useStyles();
    const DEFAULT_SIZE = 'large'
    const {
        className,
        size,
        isLoading,
        ...otherProps
      } = props;   
    const classNames = ['jetButton',classes.jetButton,classes[`jetButton__${props.variation}` ],`jetButton__size__${props.size || DEFAULT_SIZE}`, className].join(' ');

    return <MuiButton  {...otherProps} className={classNames}>
        {isLoading ? <JetSpinner/> : props.children }       
      </MuiButton>
}


export default JetButton